module.exports = __webpack_public_path__ + "images/icons_v2/metric-outlined-8f9ee898.svg";